import React from 'react';

const MIN_GRID_SIZE = 4;

export const BoardMapGridLayer = ({
  grid,
  canvasWidth,
  canvasHeight,
  viewport,
  viewportWidth,
  viewportHeight,
  offsetX = 0,
  offsetY = 0,
}) => {
  if (grid?.visible !== true) {
    return null;
  }

  const size = Math.max(MIN_GRID_SIZE, Math.round(Number(grid?.size) || 0));
  if (!Number.isFinite(size) || size <= 0) {
    return null;
  }

  const color = String(grid?.color || 'contrast').trim() || 'contrast';
  const opacity = Number.isFinite(Number(grid?.opacity))
    ? Math.max(0, Math.min(1, Number(grid.opacity)))
    : 0.16;
  const safeZoom = Math.max(Number(viewport?.zoom) || 1, 0.05);
  const safeViewportWidth = Math.max(1, Number(viewportWidth) || canvasWidth);
  const safeViewportHeight = Math.max(1, Number(viewportHeight) || canvasHeight);
  const leftBound = Math.min(0, -((Number(viewport?.x) || 0) / safeZoom));
  const topBound = Math.min(0, -((Number(viewport?.y) || 0) / safeZoom));
  const rightBound = Math.max(
    canvasWidth,
    (safeViewportWidth - (Number(viewport?.x) || 0)) / safeZoom,
  );
  const bottomBound = Math.max(
    canvasHeight,
    (safeViewportHeight - (Number(viewport?.y) || 0)) / safeZoom,
  );
  const layerWidth = rightBound - leftBound;
  const layerHeight = bottomBound - topBound;
  const startX = Math.floor((leftBound - offsetX) / size) * size + offsetX;
  const startY = Math.floor((topBound - offsetY) / size) * size + offsetY;
  const lines = [];

  for (let x = startX; x <= rightBound; x += size) {
    lines.push(
      <line
        key={`x-${x}`}
        x1={x}
        y1={topBound}
        x2={x}
        y2={bottomBound}
      />,
    );
  }

  for (let y = startY; y <= bottomBound; y += size) {
    lines.push(
      <line
        key={`y-${y}`}
        x1={leftBound}
        y1={y}
        x2={rightBound}
        y2={y}
      />,
    );
  }

  return (
    <svg
      data-testid='board-map-grid-layer'
      data-left-bound={leftBound}
      data-top-bound={topBound}
      data-right-bound={rightBound}
      data-bottom-bound={bottomBound}
      className='absolute left-0 top-0 pointer-events-none select-none'
      width={layerWidth}
      height={layerHeight}
      viewBox={`${leftBound} ${topBound} ${layerWidth} ${layerHeight}`}
      style={{
        left: leftBound,
        top: topBound,
      }}
      aria-hidden='true'
    >
      <g
        stroke={`rgb(var(--${color}))`}
        strokeWidth='1'
        opacity={opacity}
        vectorEffect='non-scaling-stroke'
      >
        {lines}
      </g>
    </svg>
  );
};
